export const SMART_COOLER_PRODUCTS_TEST_IDS = {
  PAGE: 'smart-cooler-products-page',
  SEARCH_PRODUCT_ID: 'smart-cooler-products-search-product-id',
  SEARCH_BARCODE: 'smart-cooler-products-search-barcode',
  SEARCH_NAME: 'smart-cooler-products-search-name',
  EXPORT_BTN: 'smart-cooler-products-export-btn',
  ADD_BTN: 'smart-cooler-products-add-btn',
  SUBAPP_SELECT: 'smart-cooler-products-subapp-select',
  DELETED_TOGGLE: 'smart-cooler-products-deleted-toggle',
  TABLE: 'smart-cooler-products-table',
  TABLE_ROW: (id: string) => `smart-cooler-products-table-row-${id}`,
  COL_SCP_ID: (id: string) => `smart-cooler-products-col-scp-id-${id}`,
  COL_LEGACY_ID: (id: string) => `smart-cooler-products-col-legacy-id-${id}`,
  COL_SUBAPP: (id: string) => `smart-cooler-products-col-subapp-${id}`,
  COL_NAME: (id: string) => `smart-cooler-products-col-name-${id}`,
  COL_STATUS: (id: string) => `smart-cooler-products-col-status-${id}`,
  COL_LAST_CHANGED: (id: string) =>
    `smart-cooler-products-col-last-changed-${id}`,
  COL_CREATED_ON: (id: string) => `smart-cooler-products-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `smart-cooler-products-col-updated-on-${id}`,
  COL_EDIT_BTN: (id: string) => `smart-cooler-products-col-edit-btn-${id}`,
  COL_DELETE_BTN: (id: string) => `smart-cooler-products-col-delete-btn-${id}`,
  COL_ACTIVATE_BTN: (id: string) =>
    `smart-cooler-products-col-activate-btn-${id}`,

  // ── CrudCoolerProductModal ───────────────────────────────────────────────
  MODAL_SUBAPP_SELECT: 'smart-cooler-products-modal-subapp-select',
  MODAL_SHORT_NAME_INPUT: 'smart-cooler-products-modal-short-name-input',
  MODAL_FULL_NAME_INPUT: 'smart-cooler-products-modal-full-name-input',
  MODAL_SMART_PRODUCT_ID_INPUT:
    'smart-cooler-products-modal-smart-product-id-input',
  MODAL_LEGACY_ID_INPUT: 'smart-cooler-products-modal-legacy-id-input',
  MODAL_BARCODES_INPUT: 'smart-cooler-products-modal-barcodes-input',
  MODAL_IMAGE_INPUT: 'smart-cooler-products-modal-image-input',
  MODAL_HYPHEN_TOGGLE: 'smart-cooler-products-modal-hyphen-toggle',
  MODAL_CANCEL_BTN: 'smart-cooler-products-modal-cancel-btn',
  MODAL_SAVE_BTN: 'smart-cooler-products-modal-save-btn',

  // ── Expanded row panel ───────────────────────────────────────────────
  EXPANDED_PANEL: 'smart-cooler-products-expanded-panel',
  EXPANDED_TAB_CONTROL: 'smart-cooler-products-expanded-tab-control',
  EXPANDED_IMAGE: 'smart-cooler-products-expanded-image',
  EXPANDED_BARCODES: 'smart-cooler-products-expanded-barcodes',
  EXPANDED_BARCODE_VALUE: (id: string) =>
    `smart-cooler-products-expanded-barcode-value-${id}`,
  EXPANDED_PRODUCT_INFO: 'smart-cooler-products-expanded-product-info',
  EXPANDED_HISTORY: 'smart-cooler-products-expanded-history',
  EXPANDED_HISTORY_VIEW_USER_BTN: (id: string) =>
    `smart-cooler-products-expanded-history-view-user-btn-${id}`,
  EXPANDED_HISTORY_PAYLOAD_BTN: (id: string) =>
    `smart-cooler-products-expanded-history-payload-btn-${id}`,
  EXPANDED_HISTORY_ERROR_BTN: (id: string) =>
    `smart-cooler-products-expanded-history-error-btn-${id}`,
  EXPANDED_HISTORY_PAYLOAD_CONTENT: (id: string) =>
    `smart-cooler-products-expanded-history-payload-content-${id}`,
  EXPANDED_HISTORY_ERROR_ROW: (id: string) =>
    `smart-cooler-products-expanded-history-error-row-${id}`,
} as const;
